module.exports = require("nestjs-custom-injector");